var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMessageAdd2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 22.75c-.96 0-1.75-.79-1.75-1.75V8c0-4.42 2.33-6.75 6.75-6.75h8c4.42 0 6.75 2.33 6.75 6.75v8c0 4.42-2.33 6.75-6.75 6.75H3zM2.75 8v13c0 .14.11.25.25.25h13c3.58 0 5.25-1.67 5.25-5.25V8c0-3.58-1.67-5.25-5.25-5.25H8C4.42 2.75 2.75 4.42 2.75 8z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.5 12h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7c.41 0 .75.34.75.75s-.34.75-.75.75h-7z",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12 15.5v-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 15.5v-7c0-.41.34-.75.75-.75s.75.34.75.75v7c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fill: "#292D32",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMessageAdd2);
export default __webpack_public_path__ + "static/media/vuesax-outline-message-add_2.dd27b99972fc5be1144922336b9ce18a.svg";
export { ForwardRef as ReactComponent };